module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/binnacle/binnacle.component.css
// module id = ./src/app/binnacle/binnacle.component.css
// module chunks = main